import React from 'react';
import {View} from 'react-native';
import Svg, {Circle} from 'react-native-svg';
import {useTheme} from '@rn-vui/themed';

import Text from '../../themed/Text';

type CountdownTimerProps = {
  seconds: number;
  total: number;
  size?: number;
  testID?: string;
};

function CountdownTimer({seconds, total, size = 24, testID}: CountdownTimerProps) {
  const {theme} = useTheme();

  const safeTotal = Math.max(total, 1);
  const safeSeconds = Math.max(0, Math.min(seconds, safeTotal));

  const strokeWidth = 2;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const remainingPct = safeSeconds / safeTotal;
  const dashOffset = circumference * (1 - remainingPct);

  const strokeColor = theme.colors.linkPrimary ?? '#1A56DB';
  const trackColor = theme.colors.borderSubtle ?? '#E5E7EB';
  const textColor = theme.colors.textMuted ?? '#6B7280';

  return (
    // No live region: per-tick announcements would spam screen readers.
    <View
      accessibilityRole="timer"
      accessibilityLabel={`Resend available in ${safeSeconds} seconds`}
      testID={testID}
      style={{flexDirection: 'row', alignItems: 'center', gap: 8}}>
      <Svg width={size} height={size}>
        <Circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={trackColor}
          strokeWidth={strokeWidth}
          fill="none"
        />
        <Circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={dashOffset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </Svg>
      <Text variant="body2" style={{color: textColor}}>{`Resend in ${safeSeconds}s`}</Text>
    </View>
  );
}

export default CountdownTimer;
